import {Dialog} from 'primereact/dialog'
import React, { useState, useRef } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { Ripple } from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';
import {useDispatch, useSelector} from 'react-redux'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useLogoutMutation} from '../redux/services/auth'
import {
	setShowMobileSidebar,
	setUnsavedChanges
} from '../redux/slices/app.slice'

import * as styles from './MobileSidebar.module.css'

const MobileSidebar = ({menuItems, title}) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	
	const showMobileSidebar = useSelector(state => state.app.showMobileSidebar);
	const unsavedChanges = useSelector(state => state.app.unsavedChanges);
	
	const [showAlertDialog, setShowAlertDialog] = useState(false);
	const [link, setLink] = useState('');
	
	const confirmLink = () => {
		setShowAlertDialog(false)
		dispatch(setUnsavedChanges(false))
		navigate(link)
	}
	
	const closeSidebar = () => {
		dispatch(setShowMobileSidebar(false))
	}
	
	const [
		logout,
		{ isSuccess: isLogoutSuccess, isError: isLogoutError, error: logoutError },
	] = useLogoutMutation();
	
	const linkClick = (e, link) => {
		e.preventDefault()
		
		dispatch(setShowMobileSidebar(false))
		
		if(unsavedChanges) {
			setShowAlertDialog(true)
			setLink(link)
		}
		else
			navigate(link)
	}
	
	const handleLogout = () => {
		logout();
	};
	
	return (
		<div className="card flex justify-content-center">
			<Sidebar
				className={styles.sidebar}
				visible={showMobileSidebar}
				onHide={closeSidebar}
				dismissable={true}
				content={({ closeIconRef, hide }) => (
					<div className="min-h-screen flex relative lg:static surface-ground">
						<div className="flex flex-column h-full w-full">
							<h2>{title}</h2>
							
							<ul className="list-none p-0 m-0">
								{menuItems.map((menuItem) => {
									return (
										<li
											className={`${
												location.pathname.endsWith(menuItem.id)
													? styles.active
													: styles.hover
											}`}
											key={menuItem.id}
										>
											<Link
												to={menuItem.link}
												className={` flex align-items-center cursor-pointer  w-full ${
													location.pathname.endsWith(menuItem.id)
														? styles.active
														: styles.hover
												}`}
												onClick={e=>linkClick(e, menuItem.link)}
											>
												<i className={`pi ${menuItem.icon}`}></i>
												<span className="font-medium">{menuItem.title}</span>
											</Link>
										</li>
									);
								})}
							</ul>
							
							{localStorage.getItem("access_token") && (
								<Button icon="pi pi-sign-out" text severity='danger' className={styles.logoutBtn} onClick={handleLogout}>LOG OUT</Button>
							)}
						</div>
					</div>
				)}
			></Sidebar>
			
			<Dialog
				closable={false}
				header={
					<div style={{ width: "100%", textAlign: "center" }}>
						Leave page?
					</div>
				}
				visible={showAlertDialog}
				onHide={() => {
					setShowAlertDialog(false);
				}}
				footer={() => (
					<div className="flex flex-column gap-2 justify-content-end">
						<Button
							label="Leave"
							className={`p-button-success ${styles.confirmDialogBtn}`}
							onClick={confirmLink}
						/>
						<Button
							label="Cancel"
							text
							className={`p-button-success ${styles.cancelDialogBtn}`}
							onClick={() => {
								setShowAlertDialog(false);
							}}
						/>
					</div>
				)}
				className={`p-fluid ${styles.alertModal}`}
			>
				<div className={styles.text}>
          <span>
            Changes you made may not be saved.
          </span>
				</div>
			</Dialog>
		</div>
	)
}

export default MobileSidebar;